import { useMemo } from 'react';

import { ServiceType as ServiceTypeSlug } from '@rover/constants/src/translations/service.constants';
import { PetType } from '@rover/types/src/Pet';

import useBrandSpecificPets from './useBrandSpecificPets';

const DOG_ONLY_SERVICES = [ServiceTypeSlug.DOGGY_DAY_CARE, ServiceTypeSlug.DOG_WALKING];

const isDogOnlyService = (serviceType: string): boolean => {
  return DOG_ONLY_SERVICES.includes(serviceType as ServiceTypeSlug);
};

/**
 * Hook that returns available pet types for a given service type.
 * Automatically filters out cats for dog-only services (Boarding, Doggy Daycare, Dog Walking).
 *
 * @param serviceType - The current service type slug
 * @returns Array of available pet types for the given service
 */
const useAvailablePets = (serviceType: string): string[] => {
  const brandSpecificPets = useBrandSpecificPets();
  const availablePets = useMemo(() => {
    if (isDogOnlyService(serviceType)) {
      return brandSpecificPets.filter((pet) => pet !== PetType.CAT);
    }
    return brandSpecificPets;
  }, [serviceType, brandSpecificPets]);

  return availablePets;
};

export default useAvailablePets;
